module.exports = {"TXTWCL_Suggested_amounts":{"id":"TXTWCL_Suggested_amounts","defaultMessage":"Suggested amounts","track":"Suggested amounts"}}